import { call, select, put } from 'redux-saga/effects';
import { proactiveAdd } from '../../actions';
import * as api from '../../actions/api';
import { getLocation, getVisitor } from '../../selectors/conversation';
import { getSettings } from '../../selectors/settings';
import { ConversationState, VisitorState } from '../../typedefs/store';

/**
 * Saga to check for incentives on the current VDP. If they exist, will give the
 * user an option to create a conversation.
 */
export function* incentiveSaga(): any {
    const { extraContext, useBot } = yield select(getSettings);
    const shouldUseBot = Boolean(parseFloat(useBot));

    if (!shouldUseBot || !extraContext || !extraContext.vehicleOfInterest || !extraContext.vehicleOfInterest.vin) {
        return;
    }

    const visitor: VisitorState = yield select(getVisitor);
    const { id: locationId } = yield select(getLocation);

    const { data } = yield call(
        api.hasIncentives,
        locationId,
        extraContext.vehicleOfInterest,
        visitor,
    );

    if (data && data.hasOffers) {
        yield put(
            proactiveAdd(
                'Would you like to see offers and incentives for this vehicle?',
                'Do you have any offers on this vehicle?'
            )
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/proactive/incentivesSaga.ts